import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CashFlow from "../../../containers/modules/report/cash-flow";

export default function CashFlowRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="cash-flow"
      index
      element={
        <AccessControl
          name={"Cash Flow Show"}
          auth={authUser}
          component={() => <CashFlow />}
        />
      }
    ></Route>
  );
}
